import { useState, useEffect, useCallback } from 'react';
import googleService from '../services/Google/GoogleService';

/**
 * Custom Hook để sử dụng OAuth Google
 * @returns {Object} - Object chứa state và methods
 */
export const useGoogle = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn] = useState(false);
  const [userData] = useState(null);
  const [code, setCode] = useState(null);
  const [error, setError] = useState(null);

  // Khởi tạo Google SDK
  useEffect(() => {
    initGoogleSDK();
  }, []);

  const initGoogleSDK = async () => {
    try {
      setIsLoading(true);
      setError(null);

      await googleService.init();

      // Kiểm tra trạng thái đăng nhập hiện tại
      // const loginStatus = googleService.isSignedIn();
      // await handleLoginStatus(loginStatus);

      // Thiết lập listener cho thay đổi trạng thái đăng nhập
      // googleService.onSignInStatusChange(handleLoginStatus);

      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  // const handleLoginStatus = async (isSignedIn) => {
  //   try {
  //     setIsLoggedIn(isSignedIn);

  //     if (isSignedIn) {
  //       // Lấy thông tin người dùng và access token
  //       const user = await googleService.getCurrentUser();
  //       const token = googleService.getAccessToken();

  //       setUserData(user);
  //       setCode(token);
  //       setError(null);
  //     } else {
  //       // Clear user data khi đăng xuất
  //       setUserData(null);
  //       setCode(null);
  //     }
  //   } catch (err) {
  //     setError(err.message);
  //     setIsLoggedIn(false);
  //     setUserData(null);
  //     setCode(null);
  //   }
  // };

  /**
   * Đăng nhập với Google
   */
  const login = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);

      await googleService.signIn();
      const accessToken = googleService.code;
      setCode(accessToken);
      // await handleLoginStatus(response);

      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  }, []);

  /**
   * Đăng xuất
   */
  const logout = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(null);

      await googleService.signOut();

      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  }, []);

  // /**
  //  * Làm mới trạng thái đăng nhập
  //  */
  // const refreshStatus = useCallback(async () => {
  //   try {
  //     setIsLoading(true);
  //     setError(null);

  //     const loginStatus = googleService.isSignedIn();
  //     await handleLoginStatus(loginStatus);

  //     setIsLoading(false);
  //   } catch (err) {
  //     setError(err.message);
  //     setIsLoading(false);
  //   }
  // }, []);

  // /**
  //  * Gọi Google API với error handling
  //  * @param {Function} apiFunction - Function để gọi API
  //  * @returns {Promise} - Promise với kết quả API
  //  */
  // const callAPI = useCallback(
  //   async (apiFunction) => {
  //     try {
  //       if (!isLoggedIn) {
  //         throw new Error("Người dùng chưa đăng nhập");
  //       }

  //       setError(null);
  //       const result = await apiFunction();
  //       return result;
  //     } catch (err) {
  //       setError(err.message);
  //       throw err;
  //     }
  //   },
  //   [isLoggedIn]
  // );

  return {
    // State
    isLoading,
    isLoggedIn,
    userData,
    code,
    error,

    // Methods
    login,
    logout,
    // refreshStatus,
    // callAPI,
  };
};

// Export default
export default useGoogle;
